import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

import { useOpenCommunitySearch } from '../../_hooks/useOpenCommunitySearch';
import { TopBarNavLinks } from './_components/TopBarNavLinks';
import { TOP_BAR_ICON_CLASSES, TOP_BAR_ICON_STROKE_WIDTH } from './_components/topBarIconClasses';

interface MobileTopBarActionsProps {
  notificationUnreadCount?: number | null;
}

export const MobileTopBarActions: FC<MobileTopBarActionsProps> = ({ notificationUnreadCount }) => {
  const { t } = useTranslation();
  const openSearch = useOpenCommunitySearch();

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        aria-label={t('community.sidebar.search_placeholder')}
        className={`${TOP_BAR_ICON_CLASSES} text-community-text-on-bg/80`}
        onClick={openSearch}
      >
        <MagnifyingGlassIcon className="size-5" strokeWidth={TOP_BAR_ICON_STROKE_WIDTH} />
      </button>
      <TopBarNavLinks notificationUnreadCount={notificationUnreadCount} />
    </div>
  );
};
